import styled from 'styled-components';
import InputMask from 'react-input-mask';

interface ILabel {
  bold?: boolean;
  error?: boolean;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & button {
      width: 30px;
      font-weight: bold;
      cursor: pointer;
  }
`;

export const Wrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  border-radius: 4px;
  transition: .2s;
  padding: 2px 0 2px 0;
`;

export const Label = styled.p<ILabel>`
  font-size: 12px;
  font-weight: ${props => props.bold ? '500' : '300'};
  margin-bottom: 4px;
  justify-content: center;
  width: auto;
  white-space: nowrap;
  text-overflow: none;

  span {
    color: red;
  }
`;

export const Input = styled.div<any>`
  width: 100%;
  background-color: ${props => props.disabled ? 'var(--opacity-background)' : 'var(--white)'};
  border: 1px solid var(--opacity-background);
  border-radius: 4px;
  padding: 6px 8px 6px 8px;
  white-space: nowrap;
  box-shadow: none;
  color: var(--primary-text-color);
  font-size: 14px;
  font-weight: 400;

  cursor: pointer;

  &:focus-within {
    border: 1px solid var(--primary);
  }
`;

export const DateMaskInput = styled(InputMask)`
  width: 100%;
  background-color: ${props => props.disabled ? 'var(--opacity-background)' : 'var(--white)'};
  border: 1px solid var(--opacity-background);
  border-radius: 4px;
  padding: 6px 8px 6px 8px;
  white-space: nowrap;
  box-shadow: none;
  color: var(--primary-text-color);
  font-size: 14px;
  font-weight: 400;

  /* cursor: pointer; */

  &:focus-within {
    border: 1px solid var(--primary);
  }
`;